import React from "react";
import { Helmet } from "react-helmet";
import GeneralStrings from "../../strings/GeneralStrings.json";
import GeneralConst from "../../consts/GeneralConst";
import HomepageNavbar from "../../components/HomepageNavbar/HomepageNavbar";
import Footer from "../../components/Footer/Footer";
import "./PrivacyPolicyPage.scss";

const PrivacyPolicyPage = () => {
  const PRIVACY_POLICY_STRINGS = GeneralStrings.PRIVACY_POLICY;
  const TITLE = `${PRIVACY_POLICY_STRINGS.BANNER_HEADING} | ${GeneralConst.SITE_NAME}`;

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <div className="privacy-policy-page">
        <HomepageNavbar transparentNavbar={false} />
        <section className="page-banner">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8 col-xl-7">
                <div className="banner-heading">
                  <h1>{PRIVACY_POLICY_STRINGS.BANNER_HEADING}</h1>
                  <p className="banner-subheading">
                    {PRIVACY_POLICY_STRINGS.BANNER_SUBTEXT}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="container">
          <div className="row privacy-policy-content">
            <div className="col-sm-12 policy-item">
              <h3>{PRIVACY_POLICY_STRINGS.INFORMATION_COLLECTED.HEADER}</h3>
              <span
                dangerouslySetInnerHTML={{
                  __html:
                    PRIVACY_POLICY_STRINGS.INFORMATION_COLLECTED
                      .DESCRIPTION_HTML,
                }}
              />
            </div>
            <hr />
            <div className="col-sm-12 policy-item">
              <h3>{PRIVACY_POLICY_STRINGS.INFORMATION_USED.HEADER}</h3>
              <span
                dangerouslySetInnerHTML={{
                  __html:
                    PRIVACY_POLICY_STRINGS.INFORMATION_USED.DESCRIPTION_HTML,
                }}
              />
            </div>
            <hr />
            <div className="col-sm-12 policy-item">
              <h3>{PRIVACY_POLICY_STRINGS.INFORMATION_PROTECTION.HEADER}</h3>
              <p>{PRIVACY_POLICY_STRINGS.INFORMATION_PROTECTION.DESCRIPTION}</p>
            </div>
            <hr />
            <div className="col-sm-12 policy-item">
              <h3>{PRIVACY_POLICY_STRINGS.INFORMATION_SHARING.HEADER}</h3>
              <span
                dangerouslySetInnerHTML={{
                  __html:
                    PRIVACY_POLICY_STRINGS.INFORMATION_SHARING.DESCRIPTION_HTML,
                }}
              />
            </div>
            <hr />
            <div className="col-sm-12 policy-item">
              <h3>{PRIVACY_POLICY_STRINGS.YOUR_RIGHTS.HEADER}</h3>
              <span
                dangerouslySetInnerHTML={{
                  __html: PRIVACY_POLICY_STRINGS.YOUR_RIGHTS.DESCRIPTION_HTML,
                }}
              />
            </div>
            <hr />
            <div className="col-sm-12 policy-item">
              <h3>{PRIVACY_POLICY_STRINGS.POLICY_CHANGES.HEADER}</h3>
              <p>{PRIVACY_POLICY_STRINGS.POLICY_CHANGES.DESCRIPTION}</p>
            </div>
            <hr />
            <div className="col-sm-12 policy-item">
              <h3>{PRIVACY_POLICY_STRINGS.CONTACT_US.HEADER}</h3>
              <span
                dangerouslySetInnerHTML={{
                  __html: PRIVACY_POLICY_STRINGS.CONTACT_US.DESCRIPTION_HTML,
                }}
              />
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default PrivacyPolicyPage;
